import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip } from "recharts";
import { formatINR } from "../../../lib/loanMath";

function DonutTip({ active, payload }) {
  if (!active || !payload?.length) return null;
  const d = payload[0].payload;
  return (
    <div className="card-flat p-2 text-[11px]" data-testid="chart-tooltip">
      <b>{d.label}</b>: {formatINR(d.value)} ({d.pct}%)
    </div>
  );
}

export function DonutChart({ data, display, colors, hidden, uid }) {
  const shown = data.filter((d) => !hidden.has(d.key));
  return (
    <div className="h-[300px] md:h-[340px] flex items-center" data-testid="custom-chart">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <defs>
            {data.map((d) => (
              <pattern key={d.key} id={`${uid}-dpat-${d.key}`} width="6" height="6" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
                <rect width="6" height="6" fill={d.color} />
                {d.key.startsWith("i") && <line x1="0" y1="0" x2="0" y2="6" stroke="#fff" strokeOpacity="0.55" strokeWidth="2" />}
              </pattern>
            ))}
          </defs>
          <Pie data={shown} dataKey="value" nameKey="label" innerRadius="52%" outerRadius="80%"
               isAnimationActive={false} stroke={colors.bg} strokeWidth={2}
               label={({ payload }) => (display === "pct" ? `${payload.pct}%` : formatINR(payload.value, true))}
               labelLine={false} fontSize={10}>
            {shown.map((d) => <Cell key={d.key} fill={`url(#${uid}-dpat-${d.key})`} />)}
          </Pie>
          <Tooltip content={<DonutTip />} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
